
import Slider from 'rc-slider';
import Maps from '../maps.json'
import 'rc-slider/assets/index.css';


const FloorSelector = ({floorHandler, mapIndex, floorIndex}) => {

    const handleStyle = {marginBottom: "10px", width: '18px', height: '18px', backgroundColor: '#FFAD05', border : '2px solid #FFAD08', borderRadius: "10%"};
    const railStyle = {height: '8px', backgroundColor: '#ffd900'};
    const dotStyle = {
    transform: "translate(-8px,5px)",
    width: "15px",
    height: "15px",
    backgroundColor: "#FFEA00",
    border: "2px solid #FFEA00",
    borderRadius: "10%"};
  

    return (
        <div className='block min-h-[100px] w-40 text-center font-zion '>
            <p className='mb-2'> Piano </p>
            <Slider value={floorIndex} tabIndex={floorIndex} activeDotStyle={dotStyle} dotStyle={dotStyle} handleStyle={handleStyle} railStyle={railStyle} min={0} max={Maps.maps.at(mapIndex).floors.length - 1} marks={Maps.maps.at(mapIndex).floors.map((floor,index) => floor.level)} included={false} onChange ={floorHandler} step={10} defaultValue={floorIndex}/>
        </div>
    )
}

export default FloorSelector